// Libraries
import { Component } from "react";
import { Link } from "react-router-dom";

// Assets
import "./../assets/styles/About.css";
import profileImg from "./../assets/images/profile.jpg";

class About extends Component {
    render() {
        return(
            <div id="about">
                <div className="container fadeIn">
                    <div className="section s1 slideIn">
                    <h1 className="slideIn">A Little Bit About Me...</h1>
                        <p>Hello! My name is Vincent Yen. I am a software artisan and U.S. Navy Veteran from the Bay Area in California. 
                            My professional journey spans across a multitude of professional realms.
                            I've worked on a variety of different projects most of which have focused on Full Stack Web Development. 
                            I have written from the many different languages of the computer such as: C++, Python, and Java,  
                            leveraged tools including: React, Angular, and Node.js, 
                            and harnessed the power of Data Science through tools like: Pandas, NumPy, Scikit-Learn, and NLTK. 
                            When I'm not working, I like to spend my time with friends or helping the community in a variety of different ways. 
                        </p>
                        <Link to="/statement_of_faith" className="link" id="faith">Statement of Faith</Link>
                    </div>
                    <div className="section s2">
                        <img id="profileImg" src={profileImg} alt="" />
                    </div>
                </div>
            </div>
        );
    };
};

export default About;